// extracted by mini-css-extract-plugin
var _1 = "g_T5j";
var _2 = "QrkZH";
export { _1 as "body", _2 as "copyButton" }
